import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f0bb04a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entry_base_regist_error_contents_wrapper" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<h1 class=\"entry_base_title\" data-v-3f0bb04a><span class=\"entry_base_title_text\" data-v-3f0bb04a>ご入力のメールアドレスは</span><span class=\"entry_base_title_text\" data-v-3f0bb04a>既に登録されている可能性があります</span></h1><p class=\"entry_base_text\" data-v-3f0bb04a><span class=\"entry_base_text_clause\" data-v-3f0bb04a>「ログイン画面へ」ボタンをクリックし、</span><span class=\"entry_base_text_clause\" data-v-3f0bb04a>マイページにログインしてください</span></p>", 2)
const _hoisted_5 = { class: "entry_base_button" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"entry_base_note\" data-v-3f0bb04a><p class=\"entry_base_mail_title\" data-v-3f0bb04a>＜総合窓口＞</p><p class=\"entry_base_mail_text\" data-v-3f0bb04a> メール <a class=\"text_link\" href=\"mailto:webmaster@massmedian.co.jp\" data-v-3f0bb04a>webmaster@massmedian.co.jp</a></p><p class=\"entry_base_mail_annotation\" data-v-3f0bb04a> 原則として営業時間の範囲内でご返答してまいります。 <br data-v-3f0bb04a> 営業時間外にいただいたお問い合わせは翌営業日より順次対応いたします。 <br data-v-3f0bb04a> 予めご了承ください。 <br data-v-3f0bb04a> 【営業時間】10:00～18:00（年末年始、土・日曜日、祝日、当社休業日を除く） </p></div>", 1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<h1 class=\"entry_base_title\" data-v-3f0bb04a>アカウントを登録できません</h1><p class=\"entry_base_text\" data-v-3f0bb04a><span class=\"entry_base_text_clause\" data-v-3f0bb04a>過去にマスメディアンの転職サービスを利用し、</span><span class=\"entry_base_text_clause\" data-v-3f0bb04a>現在利用を停止している可能性があります</span><br data-v-3f0bb04a><span class=\"entry_base_text_clause\" data-v-3f0bb04a>「転職支援サービスを再開する」ボタンをクリックし、お手続きください</span></p>", 2)
const _hoisted_10 = { class: "entry_base_button" }

import { computed } from 'vue';

import { useRouter } from 'vue-router';

import BaseButton from '@/components/BaseButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RegistError',
  props: {
  code: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props

const router = useRouter();

const errorCodeType = computed(() => {
  if (props.code === 'EA002') {
    return 'isRegistered';
  } else if (props.code === 'EA001') {
    return 'unAbleRegist';
  } else {
    return 'other';
  }
});

const transitionLoginPage = () => {
  router.push({ name: 'a10' });
};

const transitionRestartAccountPage = () => {
  router.push({ name: 'q01'});
};

if (errorCodeType.value === 'other') {
  transitionLoginPage();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(errorCodeType) === 'isRegistered')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(BaseButton, {
                theme: "primary",
                type: "button",
                onClick: transitionLoginPage
              }, {
                default: _withCtx(() => [
                  _createTextVNode("ログイン画面へ")
                ]),
                _: 1
              })
            ]),
            _hoisted_6
          ]))
        : (_unref(errorCodeType) === 'unAbleRegist')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_10, [
                _createVNode(BaseButton, {
                  theme: "primary",
                  type: "button",
                  onClick: transitionRestartAccountPage
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("転職支援サービスを再開する")
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
    ])
  ]))
}
}

})